import aboutMarkdown from "./about.md" with { type: "text" };
import blogMarkdown from "./blog.md" with { type: "text" };
import changelogMarkdown from "./changelog.md" with { type: "text" };
import termsOfServiceMarkdown from "./terms-of-service.md" with { type: "text" };
import privacyPolicyMarkdown from "./privacy-policy.md" with { type: "text" };

export type ContentPageKey =
  | "about"
  | "blog"
  | "changelog"
  | "terms-of-service"
  | "privacy-policy";

export type ContentPageDefinition = {
  title: string;
  lastUpdated?: string;
  markdown: string;
};

export const contentPages: Record<ContentPageKey, ContentPageDefinition> = {
  about: {
    title: "About",
    markdown: aboutMarkdown,
  },
  blog: {
    title: "Blog",
    markdown: blogMarkdown,
  },
  changelog: {
    title: "Changelog",
    markdown: changelogMarkdown,
  },
  "terms-of-service": {
    title: "Terms of Service",
    lastUpdated: "March 2, 2026",
    markdown: termsOfServiceMarkdown,
  },
  "privacy-policy": {
    title: "Privacy Policy",
    lastUpdated: "March 10, 2026",
    markdown: privacyPolicyMarkdown,
  },
};
